import { Instance } from 'mobx-state-tree'
import { DailyInspirationResponseReportsModelBase } from './DailyInspirationResponseReportsModel.base'

/* The TypeScript type of an instance of DailyInspirationResponseReportsModel */
export interface DailyInspirationResponseReportsModelType
  extends Instance<typeof DailyInspirationResponseReportsModel.Type> {}

/* A graphql query fragment builders for DailyInspirationResponseReportsModel */
export {
  selectFromDailyInspirationResponseReports,
  dailyInspirationResponseReportsModelPrimitives,
  DailyInspirationResponseReportsModelSelector
} from './DailyInspirationResponseReportsModel.base'

/**
 * DailyInspirationResponseReportsModel
 */
export const DailyInspirationResponseReportsModel = DailyInspirationResponseReportsModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
